/**
 * The one way to send someone to verify a website: the dashboard home reads
 * `?verify=<slug>` and opens that row's ownership dialog on arrival, so a
 * "Verify" button elsewhere is one click, not a hunt for the site and its
 * action. Dependency-free so client components and server mail can share it.
 */
export const VERIFY_DEEP_LINK_ROUTE = "/dashboard" as const;

/** Search params for a router `<Link to={VERIFY_DEEP_LINK_ROUTE}>`. */
export function verifyDeepLinkSearch(slug: string): { verify: string } {
	return { verify: slug };
}

/** Plain path for places that carry a string (next-action card, mail). */
export function verifyDeepLinkPath(slug: string, source?: string): string {
	const path = `${VERIFY_DEEP_LINK_ROUTE}?verify=${encodeURIComponent(slug)}`;
	return source ? `${path}&source=${encodeURIComponent(source)}` : path;
}
